import { editorPicks } from "@/mocks/home";

export default function EditorPicks() {
  return (
    <section id="editor" className="w-full bg-foreground-950">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-300">
              <i className="ri-quill-pen-line w-4 h-4 flex items-center justify-center text-sm" />
              Editor's Picks
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-background-50 md:text-3xl">
              编辑精选 · 值得慢慢读的三篇
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-background-300">
              热度之外的另一种选择。配图克制、文字为主，适合找一个安静的晚上读完。
            </p>
          </div>
          <a
            href="#latest"
            className="inline-flex h-11 shrink-0 items-center gap-2 whitespace-nowrap rounded-full border border-background-700 px-5 text-sm font-semibold text-background-100 transition-colors hover:border-primary-400 hover:text-primary-300"
          >
            返回列表
            <i className="ri-arrow-up-line w-4 h-4 flex items-center justify-center text-base" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {editorPicks.map((pick, index) => (
            <article
              key={pick.id}
              className="animate-fade-up group flex flex-col overflow-hidden rounded-lg bg-background-50 transition-transform duration-300 hover:-translate-y-1"
              style={{ animationDelay: `${index * 70}ms` }}
            >
              <div className="h-44 w-full overflow-hidden md:h-48">
                <img
                  src={pick.image}
                  alt={`${pick.title} · 黑料免费看料相关配图`}
                  title={`${pick.title} - 黑料免费 吃瓜看料`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2">
                  <span className="whitespace-nowrap rounded-sm bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-700">
                    {pick.category}
                  </span>
                  <span className="text-xs text-foreground-500">{pick.readTime}</span>
                </div>
                <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                  {pick.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {pick.summary}
                </p>
                <span className="mt-4 flex items-center gap-1 text-sm font-semibold text-primary-600">
                  免费阅读
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center text-base" />
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}